import axios from "axios";
import { fetchUserDetails, getToken } from "../../helpers";
// import { getToken } from "../../MFEs/web-authentication-sdk/src/helper";
// import { fetchUserDetails } from "../../MFEs/Monetization-Sdk/src/fetchStore";
import { getUserDetails } from "../../modules/UserManagementModule/NotificationAlerts/helper";
import { getStorageItem } from "../../helpers/storageManager";

let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl


export const getGeolocationStatus = () => {
    let status = ''
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted") {
            status = 'granted'
        } else if (result.state === "prompt") {
            status = 'prompt'
        } else {
        status = 'denied'
        }
      });
    return status
}

export const fetchUserHbaData = async() => {
    let store = getStorageItem('AuthenticationStore')
    let user = store?.user
    let isHbaEnabled = user?.hba?.enabled
    if (isHbaEnabled) {
        let byCoordinates = user?.hbaMetadata?.lookupMode === "coordinates" ? true : false
        if (byCoordinates) {
            const latitude = user?.hbaMetadata?.latitude
            const longitude = user?.hbaMetadata?.longitude
            return {postalCode: user?.hbaMetadata?.zip, latitude: latitude, longitude: longitude, countryisocode: user?.country, byCoordinates: byCoordinates, origip: user?.hbaMetadata?.ip}
        }else {
            return {postalCode: user?.hbaMetadata?.zip, countryisocode: user?.country, byCoordinates: false, origip: user?.hbaMetadata?.ip}
        }
    }
}

export const fetchHbaData = async () => {
    let userDetails = await fetchUserDetails()
    if (userDetails?.hba?.enabled) {
        const data = getUserDetails().then((res) => {
            const latitude = res?.hbaMetadata?.latitude
            const longitude = res?.hbaMetadata?.longitude
            let byCoordinates = res?.hbaMetadata?.lookupMode === "coordinates" ? true : false
            if (res?.hbaMetadata?.enabled) {
                if (byCoordinates) {
                    return getlocationViaCoords(latitude, longitude).then((res) => {
                      const locationObj = {postalCode: res.data.postalcode, latitude: latitude, longitude: longitude, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip}
                      localStorage.setItem('locationCoords', JSON.stringify(locationObj))
                      return locationObj
                    })
                }else {
                    return getlocationInfoViaIp().then((res) => {
                        const locationObj = {postalCode: res.data.postalcode, countryisocode: res.data.countryisocode, byCoordinates: false, origip: res.data.origip}
                        localStorage.setItem('locationCoords', JSON.stringify(locationObj))
                        return locationObj
                    })
                }
        }else {
            return null
        }})
        .catch(() => {
            return null
        })
        return data
    }
}

export const getlocationViaCoords = async(latitude,longitude) => {
    let token = await getToken((token) => { return token })
    return axios.get(`${baseUrl}/geolocation?latitude=${latitude}&longitude=${longitude}`, {
        headers: { Authorization: token }
    }
    )
}

export const getlocationInfoViaIp = async(latitude,longitude) => {
    let token = await getToken((token) => { return token })
    return axios.get(`${baseUrl}/geolocation`, {
        headers: { Authorization: token }
    }
    )
}

export const updateUserIdentityData = async(payload) => {
    let token = await getToken((token) => { return token })
    let { userId } = await fetchUserDetails()
    return axios.put(`${baseUrl}/v2/identity/${userId}`,payload,{
        headers: { Authorization: token }
    }
    )
}